import React, { useEffect, Fragment, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  Button,
  Grid,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import leftarc from "assets/images/leftarc.svg";
import mobileTopArc from "assets/images/mobile-top-curve.svg";
import lady from "../../assets/images/lady.png";
import doctor from "assets/images/doctor.jpg";
import "../../App.scss";
import MainText from "./MainText";
import HomeGaugeView from "./HomeGaugeView";
import TopSearches from "./TopSearches";
import CenterContent from "./CenterContent";
import CenterFooter from "./CenterFooter";
import CenterFooterMobile from "./CenterFooterMobile";
import BottomContent from "./BottomContent";
import { homeActions } from "actions";
import { connect } from "react-redux";
import RecentSearches from "./RecentSearches";
import FooterView from "components/FooterView";
import ShowHCPQRCode from "components/ShowHCPQRCode";
import SendTextMessagePopUp from "../SearchMedication/SendTextMessagePopUp";
import SendEmailMessagePopUp from "../SearchMedication/SendEmailMessagePopUp";

const Home = (props) => {
  const {
    getRecentSearch,
    getTopTenProducts,
    saveSelectedProduct,
    clearRecentSearches,
    clearRecentInfo,
    gtmInfo,
    selectedProduct,
    updateGTMDataLayer,
    profileInfo,
    organizationInfo,
  } = props;
  const locationState = useLocation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matchesMd = useMediaQuery(theme.breakpoints.down("md"));
  const matchWeb = useMediaQuery(theme.breakpoints.up("md"));
  const matchesBtwn = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const [recentSearch, setRecenteSearch] = useState("");
  const [recentTopMobile, setRecentTopMobile] = useState(true);
  const appData = JSON.parse(sessionStorage.getItem("applicationData"));
  const deviceData = JSON.parse(sessionStorage.getItem("deviceInfo"));
  const insuranceInfo = JSON.parse(localStorage.getItem("storedInsuranceData"));
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";
  const tagManagerArgs = {
    dataLayer: gtmInfo,
    dataLayerName: "PageDataLayer",
  };
  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");
 
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const widgetEnabled = sessionStorage.getItem("widgetEnabled");

  const topTenButtonRef = useRef(null);
  const [encUserData, setencUserData] = useState(null);
  const [encUserSharePopup, setEncUserSharePopup] = useState(false);

  const isPOSTemplate =
    organizationInfo?.type?.toLowerCase() === "p" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";
  
  useEffect(() => {
    if (matchesMd) {
      setRecentTopMobile(false);
    } else {
      setRecentTopMobile(true);
      setRecenteSearch("top");
    }
    topTenButtonRef?.current?.click();
  }, [matchesMd, topTenButtonRef]);

  useEffect(() => {
    if (clearRecentInfo) {
      getRecentSearch();
    }
  }, [clearRecentInfo]);

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    props.setValue(0);
    saveSelectedProduct("");
    updateGTMDataLayer({
      event: "Nav_home",
      page: "Global",
      screen: "Home",
      screen_title: "Global",
      user_id: "",
      session_id: appData?.sessionId,
      medication_name: selectedProduct?.productName,
      insurance: insuranceInfo && insuranceInfo?.name,
    });

    const encUser = locationState?.state || null;

    if (encUser) {
      let payload = { ...encUser, autoSubmitData: null };
      if (encUser?.type === "phone") {
        payload.autoSubmitData = {
          phoneNumber: encUser?.username,
          adjudicationId: encUser?.adjudicationId,
        };
      }
      if (encUser?.type === "email") {
        payload.autoSubmitData = {
          recipientName: encUser?.recipientName,
          senderName: encUser?.senderName,
          recipientEmail: encUser?.username,
          adjudicationId: encUser?.adjudicationId,
        };
      }
      setencUserData(payload);
    }
    return () => {
      updateGTMDataLayer({
        event: "Nav_home",
        screen_referrer: "home",
      });
    };
  }, []);

  useEffect(() => {
    if (encUserData) {
      setEncUserSharePopup(true);
    }
  }, [encUserData]);

  useEffect(() => {
    window.dataLayer.push({
      ...tagManagerArgs.dataLayer,
    });
  }, [gtmInfo]);

  useEffect(() => {
    if (profileInfo?.data?.id) {
      updateGTMDataLayer({
        user_id: profileInfo?.data?.id,
        event: "Sign_up_form_email_successful_sign_up",
      });
    }
  }, [profileInfo]);

  useEffect(() => {
    if (deviceData && !deviceData?.organizationSuffix && !deviceData?.id) {
      updateGTMDataLayer({
        campaign: deviceData?.organizationSuffix,
        device_id: deviceData?.id,
        event: "Sign_up_form_email_successful_sign_up",
      });
    }
  }, [deviceData]);

  const showHideRecentTop = () => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            width: "100%",
            paddingTop: defaultInsuranceId && matchWeb ? "130px" : 0,
          }}
        >
          <Button
            variant={
              recentSearch === "recent" && recentTopMobile
                ? "filled"
                : "outline"
            }
            sx={{
              marginRight: "20px",
              fontWeight: "bold",
              border: `1.3px solid ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
              color:
                recentSearch === "recent"
                  ? `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`
                  : `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
              backgroundColor:
                recentSearch === "recent"
                  ? `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`
                  : `${organizationInfo?.colorSchemeJson?.otherButtonColor}  !important`,
              padding: "6px 14px",
            }}
            onClick={() => {
              getRecentSearch();
              setRecentTopMobile(true);
              setRecenteSearch("recent");
            }}
          >
            <Typography
              sx={{
                color:
                  recentSearch === "recent"
                    ? `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`
                    : `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
              }}
              variant="h3LatoRegular"
            >
              Recent Searches
            </Typography>
          </Button>
          <Button
            variant={
              recentSearch === "top" && recentTopMobile ? "filled" : "outline"
            }
            sx={{
              fontWeight: "bold",
              border: `1.3px solid ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
              color:
                recentSearch === "top"
                  ? `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`
                  : `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
              backgroundColor:
                recentSearch === "top"
                  ? `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`
                  : `${organizationInfo?.colorSchemeJson?.otherButtonColor}  !important`,
              padding: "6px 14px",
            }}
            onClick={() => {
              getTopTenProducts();
              setRecentTopMobile(true);
              setRecenteSearch("top");
            }}
            ref={topTenButtonRef}
          >
            <Typography
              sx={{
                color:
                  recentSearch === "top"
                    ? `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`
                    : `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
              }}
              variant="h3LatoRegular"
            >
              Top Searches
            </Typography>
          </Button>
        </Box>
        <Box
          component="div"
          sx={{
            minHeight: matchesMd ? 0 : "280px",
            width: "100%",
            marginBottom: matchesBtwn ? "65px" : undefined,
          }}
        >
          {recentSearch === "recent" && recentTopMobile ? (
            <Box mt={1}>
              <Button
                variant="outline"
                sx={{
                  marginRight: 1,
                  fontWeight: "bold",
                  border: `1.3px solid ${organizationInfo?.colorSchemeJson?.gaugeColor?.wedge3Color}`,
                  color:
                    recentSearch === "top"
                      ? `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`
                      : `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
                  backgroundColor:
                    recentSearch === "top"
                      ? `${organizationInfo?.colorSchemeJson?.primaryButtonColor}  !important`
                      : `${organizationInfo?.colorSchemeJson?.otherButtonColor}  !important`,
                }}
                onClick={() => {
                  clearRecentSearches();
                  sessionStorage.removeItem("recentSearch");
                }}
              >
                <Typography
                  sx={{
                    color:
                      recentSearch === "top"
                        ? `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor}  !important`
                        : `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
                  }}
                  variant="h3LatoRegular"
                >
                  Clear
                </Typography>
              </Button>
            </Box>
          ) : (
            ""
          )}
          {recentSearch === "top" && recentTopMobile ? <TopSearches /> : null}
          {recentSearch === "recent" && recentTopMobile ? (
            <RecentSearches />
          ) : null}
        </Box>
      </>
    );
  };

  const showHideBottom = () => {
    if (isPOSTemplate) {
      return (
        <Grid
          container
          className="home-bottom-content"
          style={{ marginTop: 90 }}
        >
          <Grid item sm={12} justifyContent="center" sx={{ zIndex: 1 }}>
            <Box>
              <FooterView />
            </Box>
          </Grid>
        </Grid>
      );
    } else {
      return (
        <>
          <Box>
            <Grid container>
              <Grid item xs={12} sm={12} justifyContent="center">
                <Box
                  sx={{
                    marginTop: matches ? "24px" : "80px",
                    marginLeft: matches ? 0 : "71px",
                    marginRight: matches ? 0 : "71px",
                  }}
                >
                  <CenterContent />
                </Box>
              </Grid>
              {!matches && (
                <Grid item xs={12} sm={12} justifyContent="center">
                  <Box mx={0} sx={{ width: "100%" }}>
                    <CenterFooter />
                  </Box>
                </Grid>
              )}
              <Grid item xs={12} sm={12} justifyContent="center">
                <BottomContent />
              </Grid>
            </Grid>
          </Box>
        </>
      );
    }
  };

  return (
    <Fragment>
      {isShowBackgroundAssets && (
        <>
          <Box sx={{ display: matchesMd ? "none" : "block" }}>
            <img src={leftarc} alt="left-arc" className="left-arc" />
          </Box>
          <Box sx={{ display: matchesMd ? "block" : "none" }}>
            <img
              src={mobileTopArc}
              alt="mabile-arc"
              className="left-mobile-arc"
              style={{ transform: "rotate(180deg)" }}
            />
          </Box>
        </>
      )}
      <Box
        sx={{
          marginLeft: matches ? 0 : "51px",
          marginRight: matches ? 0 : "51px",
        }}
      >
        <Grid container direction="column">
          <Grid item container direction="row" justifyContent="center">
            <Grid item container xs={12} sm={12} md={7}>
              <Grid
                item
                xs={12}
                sx={{
                  //marginLeft: matches ? undefined : "16%",
                  // marginRight: matches ? "40px" : undefined,
                  textAlign: matches ? "center" : undefined,
                  marginBottom: "30px",
                  // display: "flex",
                  // alignItems: "center",
                  // justifyContent: "center",
                }}
              >
                <MainText />
              </Grid>

              <Grid
                item
                xs={12}
                sm={matches ? 12 : 12}
                pt={widgetEnabled?.toLowerCase() === "y" ? 6 : 0}
                sx={{ marginRight: matches ? undefined : "19px" }}
              >
                <HomeGaugeView />
              </Grid>
            </Grid>
            {matches &&
              organizationInfo?.organizationOptionJson?.showAppStoreBand?.toLowerCase() ===
                "y" && (
                <Grid item xs={12} sm={12} justifyContent="center">
                  <Box mx={0} sx={{ width: "100%" }}>
                    <CenterFooterMobile />
                  </Box>
                </Grid>
              )}
            {widgetEnabled?.toLowerCase() === "n" && (
              <Grid
                item
                container
                md={5}
                sm={12}
                xs={12}
                pt={isHCPTemplate ? 1 : 0}
                direction={isHCPTemplate ? "flex-start" : "column"}
                justifyContent="center"
                sx={{
                  marginRight: matches ? "40px" : undefined,
                  marginLeft: matches ? "40px" : undefined,
                  marginTop: matches ? "24px" : undefined,
                }}
              >
                {isHCPTemplate ? (
                  <>
                    <Box
                      sx={{
                        marginLeft: "41px",
                        display: matches ? "none" : "flex",
                        alignItems: "center",
                        width: "50%",
                      }}
                    >
                      <>
                        <Grid sx={{ display: "block" }} container>
                          <img
                            style={{ width: "100%" }}
                            src={doctor}
                            alt="doctor-lady"
                            className="doctor-image"
                          />
                          <Grid>
                            <Typography
                              variant="h1LatoBlack"
                              component={"div"}
                              sx={{
                                fontSize: "20px",
                                // lineHeight: matchesWidth ? "0px" : "55px",
                                color: "#093d4c",
                                letterSpacing: "2.08px",
                                lineHeight: "2.1rem",
                                textAlign: "center",
                              }}
                            >
                              “Finally, one savings tool that can help all my
                              patient save on their rising out-of-pocket Rx
                              cost. ”
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box
                      sx={{
                        marginLeft: "41px",
                        display: matches ? "none" : "block",
                        marginBottom: !isShowBackgroundAssets ? "15%" : "8px",
                      }}
                    >
                      {defaultInsuranceId || !isShowBackgroundAssets ? null : (
                        <img
                          src={lady}
                          alt="yoga-lady"
                          className="lady-image"
                        />
                      )}
                    </Box>
                    {showHideRecentTop()}
                  </>
                )}
                <ShowHCPQRCode />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
      {widgetEnabled?.toLowerCase() === "n" && showHideBottom()}

      {encUserSharePopup &&
        encUserData?.type === "phone" &&
        encUserData?.autoSubmitData && (
          <SendTextMessagePopUp
            autoSubmit={true}
            autoSubmitData={encUserData?.autoSubmitData}
            showSendTextMessage={true}
            onCancel={() => {
              setEncUserSharePopup(false);
            }}
          />
        )}
      {encUserSharePopup &&
        encUserData?.type === "email" &&
        encUserData?.autoSubmitData && (
          <SendEmailMessagePopUp
            autoSubmit={true}
            autoSubmitData={encUserData?.autoSubmitData}
            showSendEmailMessage={true}
            onCancel={() => setEncUserSharePopup(false)}
          />
        )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    refreshToken: state.authentication.refreshToken,
    jwtToken: state.authentication.jwtToken,
    authData: state.authentication.authData,
    recentList: state.recentSearch.data,
    clearRecentInfo: state.clearRecent.data,
    recentIsProgress: state.recentSearch.isProgress,
    selectedProduct: state.home.selectedProduct,
    gtmInfo: state.gtmInfo.data,
    profileInfo: state.profile.profileData,
    topProductsList: state.topProducts.data,
    deviceInfo: state.deviceInfo.data,
    organizationInfo: state.organizationInfo.data || {},
    organizationLogo: state.organizationLogo.data,
  };
};

const mapDispatchToProps = {
  getTopTenProducts: () => homeActions.getTopTenProducts(),
  getRecentSearch: () => homeActions.getRecentSearchList(),
  saveSelectedProduct: (value) => homeActions.saveSelectedProduct(value),
  clearRecentSearches: () => homeActions.clearRecentSearches(),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  getAppSettingsIdentity: () => homeActions.getAppSettingsIdentity(),
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
